import logger from "@utils/logger";
import { ensureFreshAccessToken } from "@utils/tokenManager";
const backendUrl = process.env.REACT_APP_BACKEND_BASE_URL;

export const fetchFilePdf = async (fileId, showError) => {
  try {
    await ensureFreshAccessToken();
    const token = localStorage.getItem("access_token");
    logger.info(`Fetching PDF for file ID: ${fileId}`);
    const response = await fetch(`${backendUrl}/files/${fileId}/pdf`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      logger.error(
        `Failed to fetch PDF for file ID: ${fileId}. Status: ${response.status}, Error: ${errorData.error}`
      );
      showError(errorData.error || "Failed to generate PDF");
      throw new Error(errorData.details || "Failed to generate PDF");
    }
    logger.info(`Successfully fetched PDF for file ID: ${fileId}`);
    return response;
  } catch (error) {
    logger.error(`Error in fetchFilePdf: ${error.message}`);
    throw error;
  }
};

export const fetchTemplatePdf = async (templateId, showError) => {
  try {
    await ensureFreshAccessToken();
    const token = localStorage.getItem("access_token");
    logger.info(`Fetching PDF for template ID: ${templateId}`);
    const response = await fetch(`${backendUrl}/templates/${templateId}/pdf`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      logger.error(
        `Failed to fetch PDF for template ID: ${templateId}. Status: ${response.status}, Error: ${errorData.error}`
      );
      showError(errorData.error || "Failed to generate PDF");
      throw new Error(errorData.error || "Failed to generate PDF");
    }
    logger.info(`Successfully fetched PDF for template ID: ${templateId}`);
    return response;
  } catch (error) {
    logger.error(`Error in fetchTemplatePdf: ${error.message}`);
    throw error;
  }
};
export const fetchPublicPdf = async (fileId, showError) => {
  try {
    await ensureFreshAccessToken();
    const token = localStorage.getItem("access_token");
    const response = await fetch(`${backendUrl}/files/${fileId}/pdf`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      const errorData = await response.json();
      showError(errorData.error || "Failed to generate PDF");
      logger.error(`Failed to fetch PDF, Error: ${errorData.error}`);
      throw new Error(errorData.error || "Failed to generate PDF");
    }
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error("Error loading PDF:", error);
    return error;
  }
};
